import React, { useEffect, useRef, useState } from 'react';
import './UpMark.css';
import { motion } from 'framer-motion';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpMark = () => {
    const countdownBarRef = useRef(null);
    const countdownBarContainerRef = useRef(null);
    const waitingMessageRef = useRef(null);
    const [wallet, setWallet] = useState(() => {
        const savedWallet = localStorage.getItem('wallet');
        return savedWallet ? parseFloat(savedWallet) : 100000;
    });
    const updateWallet = (amount) => {
        const newWallet = wallet + amount;
        setWallet(newWallet);
        localStorage.setItem('wallet', newWallet.toFixed(2));
    };

    const [showFlight, setShowFlight] = useState(false);
    const [multiplier, setMultiplier] = useState(1.0);
    const [hasFlown, setHasFlown] = useState(false);
    const [upperBetAmount, setUpperBetAmount] = useState(10);
    const [lastQuickAmount, setLastQuickAmount] = useState(null);
    const [lowerBetAmount, setLowerBetAmount] = useState(10);
    const [upperBetPlaced, setUpperBetPlaced] = useState(false);
    const [lowerBetPlaced, setLowerBetPlaced] = useState(false);
    const [isRestarting, setIsRestarting] = useState(false);
    const [targetMultiplier, setTargetMultiplier] = useState(null);
    useEffect(() => {
        const interval = setInterval(() => {
            fetch('https://aviator.khalodigital.in/api/get-predection-data')
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true") {
                        const multiplierValue = parseFloat(data.data.replace('x', ''));
                        // const multiplierValue = 1.23;
                        setTargetMultiplier(multiplierValue);
                    }
                })
                .catch(error => {
                    console.error('Error fetching target multiplier:', error);
                });
        }, 5000); // 5000ms = 5 seconds

        // Cleanup the interval on component unmount
        return () => clearInterval(interval);
    }, []);

    const countdownDuration = 10; // in seconds
    useEffect(() => {
        let countdownTimer;
        let countdown = countdownDuration; // countdownDuration is your given seconds (example: 5 seconds)
        const totalDuration = countdown * 1000;
        const updateInterval = 50;
        let elapsed = 0;

        if (!showFlight && !isRestarting) {
            if (waitingMessageRef.current) waitingMessageRef.current.textContent = "Waiting for next round";
            if (countdownBarContainerRef.current) countdownBarContainerRef.current.style.display = "block";
            if (countdownBarRef.current) countdownBarRef.current.style.width = '100%';

            countdownTimer = setInterval(() => {
                elapsed += updateInterval;
                const percentage = Math.max(0, 100 - (elapsed / totalDuration) * 100);

                if (countdownBarRef.current) {
                    countdownBarRef.current.style.width = `${percentage}%`;
                }

                if (elapsed >= totalDuration) {
                    clearInterval(countdownTimer);

                    // 🔥 After countdown finishes → START the flight after a small delay
                    setTimeout(() => {
                        setShowFlight(true);
                    }, 200); // a small 200ms smooth delay
                }
            }, updateInterval);
        }

        return () => clearInterval(countdownTimer);
    }, [showFlight, isRestarting]);


    useEffect(() => {
        let interval;
        if (showFlight && multiplier < targetMultiplier && !hasFlown) {
            interval = setInterval(() => {
                setMultiplier(prev => {
                    const updated = parseFloat((prev + 0.01).toFixed(2));
                    if (updated >= targetMultiplier) {
                        setHasFlown(true);
                        return targetMultiplier;
                    }
                    return updated;
                });
            }, 50);
        } else if (hasFlown) {
            clearInterval(interval);
            setIsRestarting(true);
            setTimeout(resetGame, 3000); // Restart after 3 seconds
        }
        return () => clearInterval(interval);
    }, [showFlight, multiplier, hasFlown]);


    // New State
    const [pendingUpperBetAmount, setPendingUpperBetAmount] = useState(0); // for middle bets

    const handleQuickBetClick = (amount, position, isQuick = false) => {
        if (position === 'upper') {
            if (isQuick) {
                if (lastQuickAmount === amount) {
                    setUpperBetAmount(prev => prev + amount);
                } else {
                    setUpperBetAmount(amount);
                    setLastQuickAmount(amount);
                }
            } else {
                setUpperBetAmount(prev => prev + amount);
                setLastQuickAmount(null);
            }
        } else if (position === 'lower') {
            if (isQuick) {
                if (lastQuickAmount === amount) {
                    setLowerBetAmount(prev => prev + amount);
                } else {
                    setLowerBetAmount(amount);
                    setLastQuickAmount(amount);
                }
            } else {
                setLowerBetAmount(prev => prev + amount);
                setLastQuickAmount(null);
            }
        }
    };

    const handleUpperBet = () => {
        if (!upperBetPlaced) {
            if (wallet >= upperBetAmount) {
                if (!showFlight) {
                    // Flight not started → Bet now
                    updateWallet(-upperBetAmount);
                    setUpperBetPlaced(true);
                } else {
                    // Flight running → Save bet for next round
                    setPendingUpperBetAmount(upperBetAmount);
                }
            } else {
                alert("Not enough balance to place bet!");
            }
        } else {
            // Cash Out
            const winningAmount = (upperBetAmount * multiplier).toFixed(2);
            updateWallet(parseFloat(winningAmount));

            toast(`You have cashed out ${multiplier.toFixed(2)}x | You got ${winningAmount}₹`, {
                position: "top-center",
                toastId: "cashout-toast-upper",
                hideProgressBar: true,
                autoClose: 3000,
                style: {
                    background: '#d4edda',
                    color: '#155724',
                    border: '2px solid #155724',
                    borderRadius: '50px',
                    padding: '12px 20px',
                },
            });

            setUpperBetPlaced(false);
            setUpperBetAmount(10);
        }
    };

    const cancelUpperBet = () => {
        // Cancel pending bet
        setPendingUpperBetAmount(0);
    };

    const resetGame = () => {
        setShowFlight(false);
        setMultiplier(1.0);
        setHasFlown(false);
        setLowerBetPlaced(false);
        setIsRestarting(false);

        if (pendingUpperBetAmount > 0) {
            // User had placed a bet in middle → Now actually place it
            setUpperBetAmount(pendingUpperBetAmount);
            updateWallet(-pendingUpperBetAmount); // Deduct money now
            setUpperBetPlaced(true);
        } else {
            setUpperBetPlaced(false);
        }

        setPendingUpperBetAmount(0); // Clear pending always
    };





    // const handleLowerBet = () => {
    //     if (!showFlight && !isRestarting) {
    //         // Logic for placing lower bet
    //     } else if (lowerBetPlaced && showFlight && !hasFlown) {
    //         // Logic for cashing out lower bet
    //     }
    // };

    const generateRandomMultipliers = () => {
        return Array.from({ length: 15 }, () => {
            const random = (Math.random() * 9 + 1).toFixed(2); // generates 1.00 - 10.00
            return `${random}x`;
        });
    };
    useEffect(() => {
        // Save initial multipliers to local storage on mount
        localStorage.setItem('multipliers', JSON.stringify(multipliers));
    }, []);  // runs once on component mount
    const [multipliers, setMultipliers] = useState(() => {
        const saved = localStorage.getItem('multipliers');
        return saved ? JSON.parse(saved) : generateRandomMultipliers();
    });



    useEffect(() => {
        if (hasFlown && targetMultiplier !== undefined) {
            const newMult = `${targetMultiplier.toFixed(2)}x`;
            setMultipliers(prev => {
                const updated = [newMult, ...prev.slice(0, 10)];  // Add the new number at the start, keep the first 4 items
                localStorage.setItem('multipliers', JSON.stringify(updated)); // Update localStorage
                return updated;
            });
        }
    }, [hasFlown, targetMultiplier]);




    return (
        <div className="game-container">
            <ToastContainer />
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px'
            }}>
                <img style={{ height: "15px" }} src="/arrow.png" alt="" />
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                        <img
                            src="/coin.png"
                            alt="coin"
                            style={{ height: "40px", marginRight: "5px", position: "absolute", right: "41px" }}
                        />
                        <span style={{
                            backgroundColor: "#0033FF",
                            color: "white",
                            padding: "2px 10px",
                            border: "2px solid #0033FF",
                            borderRadius: "8px",
                            fontWeight: "bold"
                        }}>
                            ₹0.00
                        </span>
                    </div>
                    <span style={{
                        border: "2px solid #0033FF",
                        padding: "3px 8px",
                        borderRadius: "8px",
                        color: "#0033FF",
                        fontWeight: "bold"
                    }}>
                        +
                    </span>
                </div>
            </div>

            <div className="header-bar">
                <img style={{ height: "20px", width: "80px" }} src="/logoname.png" alt="" />
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <p className="money"> {wallet.toFixed(2)} <span style={{ fontSize: "10px", color: "gray" }}>INR</span></p>
                    <div style={{ width: "fit-content", borderLeft: "1px solid rgb(72, 72, 72)" }}>
                        <div class="hamburger-menu">
                            <div class="line"></div>
                            <div class="line"></div>
                            <div class="line"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="multiplier-bar">
                {multipliers.map((mult, i) => {
                    const number = parseFloat(mult);
                    let color = "";

                    if (number >= 1 && number <= 2) {
                        color = "aqua";
                    } else if (number > 2 && number <= 4) {
                        color = "#db22fb";
                    } else if (number > 4) {
                        color = "#FC0FC0";
                    }
                    return (
                        <span key={i} style={{ color }}>{mult}</span>
                    );
                })}
            </div>


            <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 10px 1px 10px", alignItems: "center" }}>
                <p style={{ fontSize: "13px" }}>Round ID:2497514 <span style={{ backgroundColor: "rgb(53, 50, 50)", borderRadius: "10px", padding: "0 6px 0 6px" }}>▼</span></p>
                <span style={{ fontSize: "13px" }}>Ping:148ms</span>
            </div>
            <div className="multiplier-area">
                <div className={`image ${showFlight ? 'rotate-animation' : ''}`}></div>

                {!showFlight && !isRestarting && (
                    <div className='waiting-message-wrapper'
                        style={{
                            height: "212px",
                            padding: "5% 0 5% 0",
                            zIndex: "20",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "400px"
                        }}>

                        {/* Logo Row */}
                        <div>
                            <img style={{ position: "absolute", bottom: "0px", top: "150px", left: "20px", height: "40px" }} src="/plane.png" alt="" />
                            <div style={{ zIndex: "20", position: "relative", display: "flex", alignItems: "center" }}>
                                <img style={{ height: "25px", paddingRight: "7px", borderRight: "1px solid white", marginTop: "20px" }} src="/ufc.png" alt="UFC Logo" />
                                <img style={{ height: "55px", }} src="/logosc.png" alt="Aviator Logo" />
                            </div>

                            {/* Partner Text */}
                            <span style={{
                                fontWeight: "bold",
                                color: "white",
                                letterSpacing: "1px",
                                fontSize: "small",
                            }}>OFFICIAL PARTNERS</span>
                        </div>
                        {/* Countdown Progress Bar */}
                        <div ref={countdownBarContainerRef} className="countdown-bar-container">
                            <div ref={countdownBarRef} className="countdown-bar"></div>
                        </div>

                        {/* SPRIBE Box */}
                        <div style={{
                            marginTop: "12px",
                            maxWidth: "100%",
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <div style={{
                                backgroundColor: "rgba(107, 238, 107, 0.3)",
                                border: "1px solid rgba(107, 238, 107, 1)",
                                borderRadius: "5px",
                                padding: "5px 10px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}>
                                <span style={{ color: "white", fontWeight: "bold", fontSize: "12px" }}>SPRIBE</span>
                                <span style={{
                                    backgroundColor: "black",
                                    color: "rgba(107, 238, 107, 1)",
                                    borderRadius: "3px",
                                    padding: "1px 5px",
                                    marginTop: "3px",
                                    fontSize: "10px",
                                    border: "1px solid rgba(107, 238, 107, 1)"
                                }}>Official Game ✅</span>
                                <span style={{
                                    fontSize: "10px",
                                    marginTop: "3px",
                                    color: "white"
                                }}>Since 2018</span>
                            </div>

                        </div>
                    </div>


                )
                }

                <div className="playertext" style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                    {hasFlown ? (
                        <>
                            <div style={{ fontSize: "22px", fontWeight: "650" }}>FLEW AWAY!</div>
                            <div style={{ color: 'red', fontSize: "135%", fontWeight: "800" }}>{targetMultiplier}x</div>
                        </>
                    ) : (
                        <div style={{ display: showFlight ? "block" : "none", fontSize: "135%", fontWeight: "900" }}>{multiplier.toFixed(2)}x</div>
                    )}
                </div>

                <div className="main-wrapper">
                    {(showFlight &&
                        <div className="y-access" style={{ display: hasFlown ? "none" : "flex" }}>
                            <div className="moving-road-y">
                                {[...Array(20)].map((_, i) => <span key={i}></span>)}
                            </div>
                        </div>
                    )}
                    {showFlight && (
                        <div className="flight-wrapper " style={{ overflow: "hidden" }}>
                            <div style={{
                                display: hasFlown ? "none" : "block",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: "0",
                                borderRadius: "50% / 30%",
                                boxShadow:
                                    multiplier <= 2
                                        ? "10px 20px 100px 50px rgba(0, 174, 255, 0.6)"  // strong skyblue glow
                                        : multiplier <= 4
                                            ? "10px 20px 100px 45px rgba(213, 0, 251, 0.6)"  // strong purple glow
                                            : "10px 20px 100px 45px rgba(248, 14, 232, 0.6)", // strong pink glow
                                transition: "all 0.3s ease"
                            }}></div>



                            <svg className="flight-path-svg" style={{ display: hasFlown ? "none" : "block" }}>
                                {/* Red fill below the curve */}
                                <motion.path
                                    d="M10,200 Q160,200 320,50 L320,300 L0,300 Z"  // Close the path for fill
                                    fill="rgba(255,0,0,.5)"  // Transparent red
                                    animate={{
                                        d: [
                                            "M0,200 Q0,200 13,200 L10,300 L0,300 Z",
                                            "M0,200 Q80,200 303,45 L300,300 L0,300 Z",
                                            "M0,200 Q100,200 302,170 L300,300 L0,300 Z",
                                            "M0,200 Q100,200 302,45 L300,200 L0,300 Z",
                                            "M0,200 Q100,200 302,170 L300,300 L0,300 Z",
                                            "M0,200 Q100,200 302,45 L300,200 L0,300 Z",
                                            "M0,200 Q100,200 302,170 L300,300 L0,300 Z",
                                            "M0,200 Q100,200 302,45 L300,200 L0,300 Z",
                                        ]
                                    }}
                                    transition={{
                                        duration: targetMultiplier * 5,
                                        ease: "easeInOut"
                                    }}
                                />

                                {/* Main red path line */}
                                <motion.path
                                    d="M10,200 Q160,200 320,50"
                                    stroke="red"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    fill="transparent"
                                    strokeDasharray="500"
                                    animate={{
                                        strokeDashoffset: 0,
                                        d: [
                                            "M0,200 Q0,200 10,200",
                                            "M0,200 Q80,200 300,50",
                                            "M0,200 Q100,200 300,170",
                                            "M0,200 Q100,200 300,50",
                                            "M0,200 Q100,200 300,170",
                                            "M0,200 Q100,200 300,50",
                                            "M0,200 Q100,200 300,170",
                                            "M0,200 Q100,200 300,50",
                                        ]
                                    }}
                                    transition={{
                                        duration: targetMultiplier * 5,
                                        ease: "easeInOut"
                                    }}
                                />
                            </svg>


                            <motion.div
                                initial={{ x: 0, y: 200 }}
                                animate={hasFlown ? { x: 400, y: 0 } : { x: [0, 290, 290, 290, 290, 290, 290, 290], y: [200, 50, 170, 50, 170, 50, 170, 50] }}

                                transition={{
                                    duration: hasFlown ? 1 : targetMultiplier * 5,
                                    ease: "easeInOut"
                                }}
                                style={{ position: "absolute" }}
                            >
                                <img src="plane.png" alt="Plane" className="planee" />
                            </motion.div>
                        </div>
                    )}
                </div>
                {
                    (showFlight &&
                        <div className="x-access" style={{ display: hasFlown ? "none" : "flex" }}>
                            <div className="moving-road">
                                {[...Array(20)].map((_, i) => <span key={i} style={{ fontSize: "40px", borderRadius: "100%" }}></span>)}
                            </div>
                        </div>

                    )
                }
            </div >

            <div className="bottom-controls">
                {/* Upper Bet Panel */}
                <div style={{
                     border: 
                     (upperBetPlaced && !showFlight) ? '1px solid red' :  // Red border when bet is placed and no flight
                     (upperBetPlaced && showFlight) ? '1px solid #FC6A03' :  // Yellow border when cashout button is active
                     'none', 
                }} className="bet-panel">
                    <div className="top-button-container">
                        <div className="top-buttons">
                            <button className='bet-option'>Bet</button>
                            <button className='auto-option'>Auto</button>
                        </div>
                    </div>

                    <div className="betting-amount">
                        <div className="betting-section" style={{ width: '39%' }}>
                            <div className="amount-control">
                                <button onClick={() => handleQuickBetClick(-1, 'upper')}>-</button>
                                <input type="text" value={upperBetAmount.toFixed(2)} readOnly />
                                <button onClick={() => handleQuickBetClick(parseFloat(upperBetAmount.toFixed(2)), 'upper')}>
                                    +
                                </button>

                            </div>
                            <div className="quick-amounts">
                                {[10, 200, 500, 1000].map(amount => (
                                    <button key={amount} onClick={() => handleQuickBetClick(amount, 'upper', true)}>
                                        {amount.toLocaleString()}.00
                                    </button>
                                ))}


                            </div>

                        </div>
                        <button
                            onClick={handleUpperBet}
                            className={upperBetPlaced ? "cancel-btn" : "bet-btn"}
                            style={{
                                backgroundColor:
                                    (pendingUpperBetAmount > 0 || (upperBetPlaced && !showFlight))
                                        ? 'transparent'
                                        : (upperBetPlaced ? '#FC6A03' : '#28a909'), border:
                                    (pendingUpperBetAmount > 0 || (upperBetPlaced && !showFlight))
                                        ? 'none'
                                        : '1px solid rgba(255, 255, 255, 0.7)',
                                textShadow: "0.5px 0.5px 3px #000",
                                color: '#fff',
                                // textShadow: "0.5px 0.5px 3px #000"
                            }}
                        >
                            <div className='upper-bet-btn-option'>
                                {pendingUpperBetAmount > 0 || upperBetPlaced && !showFlight ? (
                                    <>
                                        {(showFlight) ? (
                                            <div style={{ fontSize: "13px", marginBottom: "5px", textShadow: "0.5px 0.5px 3px #000" }}>
                                                WAITING FOR NEXT ROUND
                                            </div>
                                        ) : null}

                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation(); // prevent the main bet button from triggering
                                                cancelUpperBet();
                                            }}
                                            className='cancel-btn'

                                            style={{
                                                width: "110%",
                                                border: "1px solid rgba(255, 255, 255, 0.7)",
                                                textShadow: "0.5px 0.5px 3px #000",
                                                ...( !showFlight && { padding: "30px", margin:"-15px",width:"120%" } )  // Apply padding when !showFlight is true
                                            }}
                                            
                                        >
                                            CANCEL
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ fontWeight: "450" }}>
                                        {upperBetPlaced ? "CASH OUT" : <>BET<br/>{upperBetAmount.toFixed(2)} INR</>}

                                    </div>
                                )}
                            </div>

                            {upperBetPlaced && showFlight && (
                                <div style={{ marginTop: "5px" }}>
                                    {(upperBetAmount * multiplier).toFixed(2)}₹
                                </div>
                            )}
                        </button>

                    </div>
                </div>

                {/* Lower Bet Panel */}
                <div className="bet-panel animated-border">
                    <div className="top-buttons">
                        <button className='bet-option'>Bet</button>
                        <button className='auto-option'>Auto</button>
                    </div>
                    <div className="betting-amount">
                        <div className="betting-section" style={{ width: '39%' }}>
                            <div className="amount-control">
                                <button onClick={() => setLowerBetAmount(prev => Math.max(0, prev - 1))}>-</button>

                                <input type="text" value={lowerBetAmount.toFixed(2)} readOnly />

                                <button onClick={() => setLowerBetAmount(prev => prev + 1)}>+</button>

                            </div>
                            <div className="quick-amounts">
                                {[10, 200, 500, 1000].map(amount => (
                                    <button key={amount} onClick={() => handleQuickBetClick(amount, 'upper')}>
                                        {amount.toLocaleString()}.00
                                    </button>
                                ))}
                            </div>

                        </div>
                        <button style={{
                            fontWeight: "450", textShadow: "0.5px 0.5px 3px #000"
                        }} className="bet-btn" disabled={showFlight}>BET <br /> 10.00 INR</button>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default UpMark;